// This file was auto-generated by Fern from our API Definition.
export const NumericOperator = {
    Eq: "eq",
    Neq: "neq",
    Gt: "gt",
    Lt: "lt",
    Gte: "gte",
    Lte: "lte",
    Btwn: "btwn",
};
